import Import from '@/transaction/Import.vue'
import TransactionView from '@/transaction/TransactionView.vue'
import { PanelContent } from '@tritt/multipanel'

export const TRANSACTIONS: PanelContent = {
    componentName: 'TransactionView',
    path: '/transactions/:uuid',
    component: TransactionView,
    meta: { requiresOrg: true }
}

export const TRANS_IMPORT: PanelContent = {
    componentName: 'TransactionImport',
    path: '/transactions/import',
    component: Import,
    meta: { requiresOrg: true }
}
